import { jQueryLikeParamSerializer } from '../utils.js';

const ENDPOINT = 'POSTsongUploadV2';
function postSongUpload(gateway, params) {
    return gateway.post(postSongUpload.endpoint, {}, jQueryLikeParamSerializer(params), null, null, 'encrypted');
}
postSongUpload.endpoint = ENDPOINT;

export { postSongUpload as default };
//# sourceMappingURL=postSongUpload.js.map
